import React from "react";
import { Link } from "react-router-dom";
// import { buildMeta } from "../../buildMeta";
import { getCopyrightNotice } from "../../utils/copyright";
import { useAccount } from "../../firebase/account";
import "./Footer.css";

const Footer = () => {
  /* The privacy policy is about accounts, so it is listed once they exist. */
  const { status } = useAccount();

  return (
    <footer className="ctb-footer">
      <div className="ctb-footer-inner">
        <p className="ctb-footer-text">{getCopyrightNotice()}</p>

        <nav aria-label="Footer">
          <ul className="ctb-footer-links">
            <li>
              <Link to="/my-study">My Study</Link>
            </li>
            <li>
              <Link to="/explorers">All Pages</Link>
            </li>
            {status !== "off" ? (
              <li>
                <Link to="/privacy">Privacy</Link>
              </li>
            ) : null}
          </ul>
        </nav>

        <p className="ctb-footer-meta">
          Built by Clint Rizzo • Data from Bible API & OpenBible API
        </p>

        {/* <p className="ctb-footer-version">
          v{buildMeta.version} • {buildMeta.commitMessage} • {buildMeta.buildDate}
        </p> */}
      </div>
    </footer>
  );
};

export default Footer;